import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import gsap from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {TextPlugin} from 'gsap/TextPlugin';
import scrollLock from 'scroll-lock';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, TextPlugin);

svg4everybody();
objectFitImages();

window.gsap = gsap;
window.objectFitImages = objectFitImages;
window.scrollLock = scrollLock;
window.ScrollTrigger = ScrollTrigger;

require('ninelines-ua-parser');
